import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Bell } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { submitWorkshopNotify } from "@/lib/api";

export default function NotifyDialog({ open, onOpenChange }) {
  const [prenom, setPrenom] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("Merci de renseigner votre email.");
      return;
    }
    setLoading(true);
    try {
      await submitWorkshopNotify({
        email: email.trim(),
        prenom: prenom.trim() || null,
      });
      toast.success("Merci, vous serez informé(e) dès l'ouverture des prochaines dates.");
      setPrenom("");
      setEmail("");
      onOpenChange(false);
    } catch {
      toast.error("Une erreur est survenue. Merci de réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="notify-dialog"
        className="sm:max-w-md bg-[#FAF7F8] border-[#DDD7E2] rounded-3xl p-0 overflow-hidden"
      >
        <div className="p-7 md:p-8">
          <DialogHeader className="text-left space-y-2">
            <span className="text-xs uppercase tracking-[0.22em] text-[#C98FA3] font-medium">
              — Restez informé
            </span>
            <DialogTitle className="font-serif-display text-3xl font-light text-[#1E1E2A]">
              Être informé des prochaines dates
            </DialogTitle>
            <DialogDescription className="text-sm text-[#5F6170]">
              Vous recevrez un message dès qu'un nouvel atelier est ouvert à l'inscription.
            </DialogDescription>
          </DialogHeader>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="notify-form">
            <div>
              <label className="text-xs uppercase tracking-[0.16em] text-[#5F6170] font-medium">
                Prénom
              </label>
              <Input
                data-testid="notify-prenom"
                value={prenom}
                onChange={(e) => setPrenom(e.target.value)}
                placeholder="Facultatif"
                className="mt-2 bg-white border-[#DDD7E2] focus-visible:ring-[#2847B8] rounded-xl h-11"
                disabled={loading}
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.16em] text-[#5F6170] font-medium">
                Email*
              </label>
              <Input
                data-testid="notify-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
                className="mt-2 bg-white border-[#DDD7E2] focus-visible:ring-[#2847B8] rounded-xl h-11"
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="notify-submit"
              className="w-full bg-[#2847B8] text-white hover:bg-[#3A2E6E] disabled:opacity-60 transition-all duration-300 rounded-full h-12 font-medium inline-flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" /> Envoi…
                </>
              ) : (
                <>
                  <Bell className="w-4 h-4" /> M'inscrire à la liste
                </>
              )}
            </button>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
}
